import { z } from "zod";

export const preferredSlotSchema = z.object({
  date: z.string().min(1), // ISO date (YYYY-MM-DD)
  time: z.string().min(1), // HH:mm
  tz: z.string().min(1),   // IANA timezone
});

export const demoRequestSchema = z.object({
  name: z.string().trim().min(1).max(120),
  email: z.string().trim().email().max(200),
  company: z.string().trim().min(1).max(160),
  teamSize: z.string().trim().min(1).max(40),
  useCase: z.string().trim().min(1).max(2000),
  message: z.string().trim().max(2000).optional().default(""),
  preferredSlots: z.array(preferredSlotSchema).min(1).max(3),
  submittedAt: z.string().min(1),
});

export type PreferredSlot = z.infer<typeof preferredSlotSchema>;
export type DemoRequest = z.infer<typeof demoRequestSchema>;

export type ValidationResult =
  | { ok: true; value: DemoRequest }
  | { ok: false; errors: Record<string, string> };

/** Validate an untrusted payload. Returns a flat field→message error map on failure. */
export function validateDemoRequest(input: unknown): ValidationResult {
  const parsed = demoRequestSchema.safeParse(input);
  if (parsed.success) return { ok: true, value: parsed.data };
  const errors: Record<string, string> = {};
  for (const issue of parsed.error.issues) {
    const key = issue.path[0];
    if (typeof key === "string" && !errors[key]) errors[key] = issue.message;
  }
  if (Object.keys(errors).length === 0) errors._ = "Invalid request.";
  return { ok: false, errors };
}
